import React, { useContext } from 'react';
import { useParams } from 'react-router';
import { useQuery } from '@tanstack/react-query';

import EntityDetail from './EntityDetail';
import Loading from '../../shared/Loading';
import NoDataError from '../../shared/NoDataError';
import useCompanyDependencies from '../../../hooks/useCompanyDependencies';
import { ApiContext } from '../../../App';
import { getCompany } from '../../../lib/actions/companies';

export default function CompanyIndex() {
  const api = useContext(ApiContext);
  const { id } = useParams();

  const {
    data: company,
    error: companyError,
    isLoading: companyLoading,
  } = useQuery({
    queryKey: ['company', id],
    queryFn: () => getCompany(api, id),
    enabled: !!id,
    retry: false,
  });

  const {
    companyProps: { isLoading },
    companyProps,
  } = useCompanyDependencies(company);

  if (companyError) return <NoDataError tag="Company" />;

  if (companyLoading || isLoading) return <Loading className="w-14 h-14" />;

  return (
    <div className="max-w-[90%] mx-auto">
      <EntityDetail props={companyProps} />
    </div>
  );
}
